import config from "./../../common/config";

export const transAPI =
  "/static-assets" +
  config.API_BASE +
  "assets/build/translations/{{lang}}.json?v={{transVersion}}";

export const tourStatusApi =
  config.ACCOUNTS_API_BASE_S3 + `constraints/eotflag_${config.tourId}.json`;

export const fixturesAPI =
  config.ACCOUNTS_API_BASE_S3_STATIC +
  `fixtures/fixtures_${config.tourId}_en.json`;

export const matchQuestionsAPI =
  config.ACCOUNTS_API_BASE_S3_STATIC +
  `matchquestions/questions_${config.tourId}`;

export const constraintsAPI =
  config.ACCOUNTS_API_BASE_S3_STATIC + `constraints/${config.tourId}.json`;

export const userPlayedGamedaysAPI =
  config.ACCOUNTS_API_BASE + "Gameplay/user/{{guid}}/predictedmatches";

export const userAnswersAPI =
  config.ACCOUNTS_API_BASE + "Gameplay/{{guid}}/getpredictions";

// URL for option selected
export const userAnswersPostAPI =
  config.ACCOUNTS_API_BASE + "Gameplay/{{guid}}/userprediction";

export const userBoosterPostAPI =
  config.ACCOUNTS_API_BASE + "Gameplay/user/{{guid}}/booster";

// https://stg-paarlroyals.sportz.io/predictor/services/api/Gameplay/user/248a3b16-7a0f-11ed-9b7c-06d445085fcd/getgameplays
// export const usermatchrankAPI =
//   config.ACCOUNTS_API_BASE + "Gameplay/user/{{guid}}/usermatchrank";
export const usermatchrankAPI =
  config.ACCOUNTS_API_BASE + "Gameplay/{{guid}}/getgameplays";

export const mixAPI =
  config.ACCOUNTS_API_BASE_S3 + `mixapi/mix_${config.tourId}.json`;

export const leaderboardAPI =
  config.ACCOUNTS_API_BASE + "Leaderboard/leaderboard";

export const leagueLeaderboardAPI =
  config.ACCOUNTS_API_BASE + "Leagues/{{leagueid}}/leaderboard";

export const leagueLeaderboardRankAPI =
  config.ACCOUNTS_API_BASE + "Leagues/user/{{guid}}/userchrank";

export const leaderboardRankAPI =
  config.ACCOUNTS_API_BASE + "Leaderboard/user/{{guid}}/userrank";

export const leagueCreateAPI =
  config.ACCOUNTS_API_BASE + "leagues/user/{{guid}}/create";

export const leagueJoinAPI =
  config.ACCOUNTS_API_BASE + "leagues/user/{{guid}}/join";

export const applyJokerAPI =
  config.ACCOUNTS_API_BASE + "Gameplay/user/{{guid}}/applyjoker";

export const getUserLeagueAPI =
  config.ACCOUNTS_API_BASE + "Leagues/user/{{guid}}/GetUserLeagues";

export const postLoginAPI = config.ACCOUNTS_API_BASE + "Session/user/login";

export const getUserBalanceAPI =
  config.ACCOUNTS_API_BASE + "Gameplay/user/{{guid}}/getuserbalance";

const objUrl = {};
export default objUrl;
